import _slugify from 'slugify';
import urlJoin from 'url-join';
export { default as urlJoin } from 'url-join';
"use strict";
const slugify = str => _slugify(str, {
  replacement: "-",
  lower: true,
  strict: true
});
function e(strings, ...placeholders) {
  let result = "";
  for (let i = 0, l = strings.length; i < l; i++) {
    result += strings[i];
    if (i < placeholders.length) {
      const placeholder = placeholders[i];
      if (placeholder != null) {
        result += encodeURIComponent(placeholder);
      }
    }
  }
  return result;
}
const createUrlBuilder = base => ({
  pathname,
  searchParams,
  overrideBasePathname,
  hash,
  returnType
}) => {
  const url = new URL(base);
  if (pathname) {
    url.pathname = overrideBasePathname ? pathname : urlJoin(url.pathname, pathname);
  }
  if (searchParams) {
    url.search = objectToSearchParams(searchParams, url.searchParams).toString();
  }
  if (hash) {
    url.hash = hash;
  }
  const urlString = url.toString();
  return returnType === "relative" ? urlString.replace(url.origin, "") : urlString;
};
const objectToSearchParams = (searchParams, urlSearchParamsInstance = new URLSearchParams()) => {
  for (const [key, value] of Object.entries(searchParams)) {
    if (value != null) {
      if (Array.isArray(value)) {
        value.forEach(v => {
          if (v != null) {
            urlSearchParamsInstance.append(key, v.toString());
          }
        });
      } else {
        urlSearchParamsInstance.append(key, value.toString());
      }
    }
  }
  return urlSearchParamsInstance;
};
const searchParamsToObject = urlSearchParams => {
  const result = {};
  urlSearchParams.forEach((value, key) => {
    if (result[key] !== void 0) {
      const storedValue = result[key];
      if (Array.isArray(storedValue)) {
        storedValue.push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else {
      result[key] = value;
    }
  });
  return result;
};
const pathnameToParts = dirtyPathname => {
  const pathname = getPurePathname(dirtyPathname);
  if (!pathname || pathname === "/") {
    return [];
  }
  const pathParts = pathname.split("/");
  if (pathname.startsWith("/")) {
    pathParts.shift();
  }
  return pathParts;
};
const partsToPathname = parts => {
  if (!parts || parts.length === 0) {
    return "/";
  }
  return `/${parts.filter(Boolean).map(encodeURIComponent).join("/")}`;
};
const getPurePathname = dirtyPathname => {
  return new URL(dirtyPathname, "https://www.example.com").pathname;
};
export { createUrlBuilder, e, getPurePathname, objectToSearchParams, partsToPathname, pathnameToParts, searchParamsToObject, slugify };
//# sourceMappingURL=url.mjs.map
